<script>
import draggable from 'vuedraggable'
import { render } from 'el-dynamic-form'

const layouts = {
    colFormItem (currentItem, index, list) {
        const config = currentItem.__config__
        const child = renderChildren.apply(this, arguments)
        let className = this.selectItem.__vModel__ === currentItem.__vModel__ ? 'drawing-item active-from-item' : 'drawing-item'
        className += ' unfocus-bordered'
        let labelWidth = config.labelWidth ? `${config.labelWidth}px` : null
        if (config.showLabel === false) labelWidth = '0'
        return (
            <el-col 
                span={config.span} 
                class={className}
                nativeOnClick={event => {
                    this.$emit('activeItem', currentItem)
                    event.stopPropagation()
                }}
            >
                <el-form-item 
                    label-width={labelWidth}
                    label={config.showLabel ? config.label : ''} 
                    required={config.required}
                >
                    <render.default 
                        key={config.renderKey} 
                        conf={currentItem}
                        onInput={event => {this.$set(config, 'defaultValue', event)}} 
                        onCreatClick={config => this.$emit('creatClick', config, index)}
                        info={{}}
                        attrs={this.$attrs}
                        design={true}
                        componentToRegister={[DraggableItem, draggable, {groupName: 'componentsGroup'}]}
                    >
                        {child}
                    </render.default>
                </el-form-item>
                {components.itemBtns.apply(this, arguments)}
            </el-col>
        )
    },
    rowFormItem (currentItem, index, list) {
        const config = currentItem.__config__
        let className = this.selectItem.__vModel__ === currentItem.__vModel__
            ? 'drawing-row-item active-from-item'
            : 'drawing-row-item'
        className += ' unfocus-bordered'
        let child = renderChildren.apply(this, arguments)
        if (currentItem.type === 'flex') {
            child = <el-row type={currentItem.type} justify={currentItem.justify} align={currentItem.align}>
                {child}
            </el-row>
        }
        return (
            <el-col span={config.span}>
                <el-row gutter={config.gutter} 
                    class={className}
                    nativeOnClick={event => {
                        this.$emit('activeItem', currentItem)
                        event.stopPropagation()
                    }}
                >
                    <span class="component-name">{config.componentName}</span>
                    <draggable list={config.children || []} animation={340} group="componentsGroup" class="drag-wrapper">
                        {child}
                    </draggable>
                    {components.itemBtns.apply(this, arguments)}
                </el-row>
            </el-col>
        )
    }
}

function renderChildren (currentItem) {
    const config = currentItem.__config__
    if (!Array.isArray(config.children)) return null
    return config.children.map((el, i) => {
        const layout = layouts[el.__config__.layout]
        if (layout) {
            return layout.call(this, el, i, config.children)
        }
    })
}

const components = {
    itemBtns (currentItem, index, list) {
        const { copyItem, deleteItem } = this.$listeners
        return [
            <span class="drawing-item-copy" style={this.inTable || currentItem.typeId === 'INFO_FEEDBACK' ? 'display:none' : ''} title="复制" onClick={event => {
                copyItem(currentItem, list)
                event.stopPropagation()
            }}>
                <i class="el-icon-copy-document"/>
            </span>,
            <span style={currentItem.typeId === 'INFO_FEEDBACK' ? 'display:none' : ''} class="drawing-item-delete" title="删除" onClick={event => {
                deleteItem(index, list)
                event.stopPropagation()
            }}>
                <i class="el-icon-delete"/>
            </span>,
        ]
    },
}
const DraggableItem = {
    name: 'DraggableItem',
    components: {
        draggable,
    },
    props: {
        currentItem: {
            type: Object,
        },
        index: {
            type: Number,
        },
        drawingList: {
            type: Array,
        },
        inTable: {
            type: Boolean,
        },
        formConf: {
            type: Object,
        },
        selectItem: {
            type: Object,
        },
    },
    render() {
        const layout = layouts[this.currentItem.__config__.layout]
        if(layout) {
            return layout.call(this, this.currentItem, this.index, this.drawingList)
        }
        return null
    }
}
export default DraggableItem
</script>
<style scoped>
::v-deep .el-radio-group,
::v-deep .el-checkbox-group {
    margin-left: 10px;
}
::v-deep .el-radio,
::v-deep .el-checkbox {
    display: block;
    min-height: 23px;
    line-height: 23px;
}
::v-deep .el-radio__label,
::v-deep .el-checkbox__label {
    font-size: 14px;
    padding-left: 10px;
    text-overflow: ellipsis;
    white-space: normal;
    min-height: 18px;
    vertical-align: middle;
    display: inline-block;
}
::v-deep .item-other-input {
    margin-left: 20px;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
::v-deep .item-other-input:focus {
    outline: none;
}
::v-deep .el-input-group__append .collect-btn{
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
}
</style>